import { create } from "zustand"

interface MailboxStore {
  selectedUserId: number | null
  setSelectedUserId: (userId: number) => void

  isOpenChildMailbox: boolean
  onCloseChildMailbox: () => void
  onOpenChildMailbox: (userId: number) => void
}

const useMailboxStore = create<MailboxStore>((set) => ({
  selectedUserId: null,
  setSelectedUserId: (userId) => set({ selectedUserId: userId }),

  isOpenChildMailbox: false,
  onCloseChildMailbox: () =>
    set({ isOpenChildMailbox: false, selectedUserId: null }),
  onOpenChildMailbox: (userId) =>
    set({ isOpenChildMailbox: true, selectedUserId: userId }),
}))

export default useMailboxStore
